export default "__VITE_ASSET__zEHI5NIQ__"